import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import DataTable from "react-data-table-component";
import { Download } from "react-feather";
import { Spinner } from "react-bootstrap";
import * as XLSX from "xlsx";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ActiveCategory = () => {
  const [categories, setCategories] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Filters
  const [searchText, setSearchText] = useState("");
  const [isCategoryFilter, setIsCategoryFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${baseurl}getAllCategoriestrue`);
        if (response.data.success) {
          setCategories(response.data.data);
          setFilteredData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    let filtered = [...categories];

    if (searchText.trim() !== "") {
      filtered = filtered.filter((item) =>
        item.title.toLowerCase().includes(searchText.toLowerCase())
      );
    }

    if (isCategoryFilter !== "all") {
      filtered = filtered.filter(
        (item) => item.is_category === (isCategoryFilter === "true")
      );
    }

    if (statusFilter !== "all") {
      filtered = filtered.filter((item) => item.status === statusFilter);
    }

    if (startDate && endDate) {
      filtered = filtered.filter((item) => {
        const created = new Date(item.created_at);
        return created >= startDate && created <= endDate;
      });
    }

    setFilteredData(filtered);
  }, [searchText, isCategoryFilter, statusFilter, startDate, endDate, categories]);

  const columns = [
    {
      name: "Sr No",
      selector: (row, index) => index + 1,
      width: "80px",
    },
    {
      name: "Image",
      selector: (row) =>
        row.image ? (
          <img
            src={`${imageUrl}menu/${row.image}`}
            alt="category"
            style={{ width: "50px", height: "50px", objectFit: "cover" }}
          />
        ) : (
          "No Image"
        ),
    },
    {
      name: "Title",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Is Category",
      selector: (row) => (row.is_category ? "✔️" : "❌"),
    },
    {
      name: "Created At",
      selector: (row) => new Date(row.created_at).toLocaleDateString(),
    },
  ];

  const handleDownloadExcel = () => {
    const exportData = filteredData.map(({ image, ...item }) => ({
      ...item,
      created_at: new Date(item.created_at).toLocaleDateString(),
    }));
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Categories");
    XLSX.writeFile(wb, "all_categories.xlsx");
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
            <h4>All Active Categories</h4>
            <div className="d-flex flex-wrap gap-2 align-items-center">
                <div className="row g-1">
                    <div className="col-md-4">
                    <input
                type="text"
                className="form-control"
                placeholder="Search Title"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
                    </div>
                    {/* <div className="col-md-2">
                    <select
                className="form-control"
                value={isCategoryFilter}
                onChange={(e) => setIsCategoryFilter(e.target.value)}
              >
                <option value="all">All</option>
                <option value="true">Is Category</option>
                <option value="false">Not Category</option>
              </select>
                    </div> */}
                    <div className="col-md-2">
                    <select
                className="form-control"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <option value="all">All Status</option>
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
                    </div>
                    <div className="col-md-2">
                    <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control"
                placeholderText="Start Date"
              />
                    </div>
                    <div className="col-md-2">
                    <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                className="form-control"
                placeholderText="End Date"
              />
                    </div>

                    <div className="col-md-2">
                    <button className="btn btn-success" onClick={handleDownloadExcel}>
                <Download size={16} /> Download
              </button>
                    </div>
                </div>
              
              
              
              
              
              
            </div>
          </div>

          <div className="card">
            <div className="card-body" style={{ padding: 0 }}>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ height: "200px" }}
                >
                  <Spinner animation="border" />
                </div>
              ) : (
                <DataTable
                  columns={columns}
                  data={filteredData}
                  pagination
                  highlightOnHover
                  responsive
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveCategory;
